webpackJsonp([144251824217401],{

/***/ 1041:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/alexa-headshot-web-min.a3d3538a.jpg";

/***/ }),

/***/ 1049:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/phil-headshot-web-min.b1e1c0a2.jpg";

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(94);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _fishrmnComponents = __webpack_require__(29);
	
	var _fishrmnTypes = __webpack_require__(43);
	
	var _config = __webpack_require__(30);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _philHeadshotWebMin = __webpack_require__(1049);
	
	var _philHeadshotWebMin2 = _interopRequireDefault(_philHeadshotWebMin);
	
	var _alexaHeadshotWebMin = __webpack_require__(1041);
	
	var _alexaHeadshotWebMin2 = _interopRequireDefault(_alexaHeadshotWebMin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    { id: "about" },
	    _react2.default.createElement(_fishrmnComponents.SEO, {
	      config: _config2.default,
	      path: _config2.default.baseConfig.pageMetadata.about.path,
	      title: _config2.default.baseConfig.pageMetadata.about.title,
	      description: _config2.default.baseConfig.pageMetadata.about.description,
	      smTypes: [_fishrmnTypes.socialMediaTypes.facebook, _fishrmnTypes.socialMediaTypes.twitter]
	    }),
	    _react2.default.createElement("div", { id: "about-hero" }),
	    _react2.default.createElement(
	      "div",
	      { id: "why-we-do-this" },
	      _react2.default.createElement(
	        "div",
	        null,
	        "OUR SMOOTHIE BōLS & COLD-PRESSED JUICE".toUpperCase()
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "span",
	          null,
	          "Are 100% organic."
	        ),
	        _react2.default.createElement(
	          "span",
	          null,
	          "Whole Sol is born out of pure passion. We've poured our heart and sol into designing, curating, and serving a menu that will power you, inspire you, and fuel you every day. And since our deepest passion is wellness, it's our job to whip up beautiful creations that will make you feel unstoppable - like you can do anything - move mountains, blast into space, or just plain KILL IT today. ",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          "Our ingredients are 100% organic, whole, and real. Our signature b\u014Dls are handcrafted to supercharge your sol. The test is simple: if we wouldn\u2019t eat it ourselves, we won\u2019t serve it to you.",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          "We aren\u2019t sorta-kinda organic, or \"committed to\" whenever possible. We just are. We invest time, money, and margins into making it happen. It's our job to ensure you walk out of Whole Sol feeling better than when you walked in, and that starts with using the highest quality, purest ingredients. Our menu is simple, nutritionist-designed, and freaking delicious. ",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          "We want you operating at 100%, so we make no excuses. You can lean on us to fuel your busiest days of working, running, swimming, and biking. But we\u2019re also cool to Netflix and chill."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "span",
	          null,
	          "We are 100% transparent."
	        ),
	        _react2.default.createElement(
	          "span",
	          null,
	          "Each b\u014Dl is handcrafted in front of you, taking the mystery out of the blend. Our blend bar is center stage at every location, giving you total visibility into how we build your b\u014Dl. Every ingredient is carefully selected with intention & purpose, so that our superfoods make you feel supercharged - not super-full or tired."
	        ),
	        _react2.default.createElement(
	          "h1",
	          { style: { textAlign: "center", fontFamily: "robotoCondensedBold" } },
	          "100% Gluten-Free | 100% Dairy-Free"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { id: "brand-promise" },
	      _react2.default.createElement(
	        "div",
	        null,
	        "OUR BRAND PROMISE"
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        "No BS*. What you see is what you get - we\u2019re honest about ingredients and our process, so you don\u2019t have to worry about what\u2019s in your food.",
	        " ",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        "Our promise to customers is to be true & honest. We showcase our ingredients and demonstrate how b\u014Dls are made to educate customers on the benefits of superfoods."
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        "*Bad stuff."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { id: "who-we-are" },
	      _react2.default.createElement(
	        "div",
	        null,
	        "WHO WE ARE"
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement("span", {
	          className: "headshot-img",
	          style: { backgroundImage: "url('" + _philHeadshotWebMin2.default + "')" },
	          role: "img",
	          "aria-label": "Phil Dumontet"
	        }),
	        _react2.default.createElement(
	          "span",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            "Phil Dumontet"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            "CEO, Co-Founder"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            "Phil Dumontet lives life in the fast lane. His need for speed inspired him to start Dashed fresh out of Boston College. Dashed grew to be one of the largest independent restaurant delivery services in the Northeast, where over 600 drivers zipped from the restaurant to customer in an average of 40 minutes or less. Phil sold Dashed to Grubhub in August 2017 shortly after being named to the Forbes\u2019 30 Under 30, a list of the most influential young entrepreneurs. He\u2019s contributed to The Washington Post, Business Insider, Fast Company, and Inc. Magazine. His best known article was about how to shower correctly (Google: \u201CPhil\u2019s daily showering trick\u201D), and was the #1 most read article on Entrepreneur.com for two months straight and syndicated to over ten news sources, including The Today Show. When Phil isn\u2019t running Whole Sol, he\u2019s out running the streets of his favorite cities, chasing his next big PR. Phil is an 11-time marathon runner and consistently finishes in the top 20 for his age group."
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "span",
	          null,
	          _react2.default.createElement(
	            "div",
	            null,
	            "Alexa Squillaro"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            "Chief Taste Officer, Co-Founder"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            "Alexa has been whipping up recipes in the kitchen for over a decade. She is a Food Master and has the street cred to prove it; she holds a Master of Science in Nutrition from Columbia University. Alexa brings a holistic approach to her position at Whole Sol, after working in both non-profit nutrition education and online food delivery businesses, where she focused in Business Development - aka she\u2019s a hustler. Her fiery approach to business spills into her personal life, where she trains for endurance races. She\u2019s run the NYC and Paris Marathon, a handful of half- marathons, and has recently entered the triathlon space. When she\u2019s not cooking up a new recipe in the Whole Sol Test Kitchen, she\u2019s cuddling at home with her three puppies, or hiking one of the nearby trails."
	          )
	        ),
	        _react2.default.createElement("span", {
	          className: "headshot-img",
	          style: { backgroundImage: "url('" + _alexaHeadshotWebMin2.default + "')" },
	          role: "img",
	          "aria-label": "Alexa Squillaro"
	        })
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-jsx-915d7d2526c3512c7b66.js